"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _withStyles = _interopRequireDefault(require("@material-ui/styles/withStyles"));

var _constants = require("../../utils/constants");

var _Backdrop = _interopRequireDefault(require("@material-ui/core/Backdrop"));

var FrostedBackdrop = function FrostedBackdrop(_ref) {
  var _ref$blur = _ref.blur,
      blur = _ref$blur === void 0 ? 8 : _ref$blur,
      background = _ref.background,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["blur", "background"]);
  var StyledBackdrop = (0, _react.useMemo)(function () {
    return (0, _withStyles["default"])(function (_ref2) {
      var _ref3;

      var palette = _ref2.palette;
      return _ref3 = {}, (0, _defineProperty2["default"])(_ref3, "@supports not ((backdrop-filter: blur(".concat(blur, "px)) or (-webkit-backdrop-filter: blur(").concat(blur, "px)))"), {
        root: {
          backgroundColor: palette.type === _constants.themeMode.LIGHT ? '#F0F0F0F0' : '#0F0F0FF0'
        }
      }), (0, _defineProperty2["default"])(_ref3, "@supports (backdrop-filter: blur(".concat(blur, "px)) or (-webkit-backdrop-filter: blur(").concat(blur, "px))"), {
        root: {
          backdropFilter: "blur(".concat(blur, "px)"),
          backgroundColor: (0, _typeof2["default"])(background) === 'object' ? background[palette.type] : background
        }
      }), _ref3;
    })(_Backdrop["default"]);
  }, [blur]);
  return /*#__PURE__*/_react["default"].createElement(StyledBackdrop, props);
};

var _default = FrostedBackdrop;
exports["default"] = _default;
//# sourceMappingURL=index.js.map